import axios from "../../utils/axios";

async function addCategory(data) {
  return await axios.post(`/single/categories`, data);
}

async function updateCategory(data, id) {
  return await axios.patch(`/single/categories/${id}`, data);
}
async function deleteCategory(id) {
  return await axios.delete(`/single/categories/${id}`);
}

async function getCategories(params) {
  return await axios.get(`/single/categories`, {
    params,
  });
}

async function getCategoryById(id) {
  return await axios.get(`/single/categories/${id}`);
}

async function updateCategoryPosition(id, data) {
  return await axios.patch(`/single/categories/${id}/position`, data);
}
async function updateCategoryStatusActivate(id) {
  return await axios.patch(`/single/categories/${id}/activate`);
}
async function updateCategoryStatusDeActivate(id) {
  return await axios.patch(`/single/categories/${id}/deactivate`);
}

export const Category = {
  addCategory,
  updateCategory,
  deleteCategory,
  getCategories,
  getCategoryById,
  updateCategoryPosition,
  updateCategoryStatusActivate,
  updateCategoryStatusDeActivate,
};
